var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tc-row",class:{ open: _vm.isActive }},[_c('div',{staticClass:"tc-row-head font-hl-black",on:{"click":_vm.toggle}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"tc-row-content"},[_c('div',{staticClass:"tc-ul font-hl-roman"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }